export const meeting_attendee_roles = {
  host: 1,
  customer: 0,
};

export const dynamic_route_var_names = {
  meetingUuid: "meetingUuid",
};

// User details params, responsible to start the meeting
export const query_params = {
  user_name: "userName",
  user_id: "userId",
  creatorUsername: "creatorUsername",
  user_email: "userEmail",
  from: "from",
  slotUuid: "slotUuid",
  is_zoom_attendance_enabled: "is_zoom_attendance_enabled", 
  session_uuid: "session_uuid",                           
};

export const default_from_url = "https://exlyapp.com/";
